import React, { useEffect, useReducer,useState } from "react";
import { Button, Col, Form, Row, Select, message } from "antd";
import ComponentsBreadcrumb from "../../layout/componentsBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { formReducer,formState } from "./reducer";
import { isErrorDispaly } from "../../shared/validationsAndExceptions/apiExceptions";
import { useHistory} from "react-router-dom";
import { arcanaAuth } from "../../auth/web3Config";
import {
  fetchCurrencyLookup, fetchMerchantLookup, setMerchantData, fetchCurrency, setCurrencyData,
  fetchNetworks,
  setCurrencyLookup,
  setNetworksData,
  setTrasferSaveData,
} from "../../reducers/transferReducer";
import { transferDetailes } from "./service";
import { store } from "../../store";
import SpinLoader from "../../shared/spinLoader";
import { cryptoMaxAllowedDecimals, validateContentRule } from "../../utils/custom.validator";
import NumberFormat from "react-number-format";
import AppAlert from "../../shared/appAlert";
import Loader from "../../shared/loader";
import WAValidator from 'multicoin-address-validator';
import networkToCoinMapping from "../../utils/networkToCoinMapping";
import useSwitchNetwork from "../../shared/useSwitchNetwork";
import {useAccount } from 'wagmi';
import { parseUnits, BrowserProvider, Contract } from 'ethers';
const WalletType = process.env.REACT_APP_WALLET_TYPE;
 
const { Option } = Select;
const ERC20_ABI = [
  "function balanceOf(address owner) view returns (uint256)",
  "function transfer(address to, uint amount) public returns (bool)"
];

const TransferComponent = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const reducerDispatch = useDispatch();
  const [localState, localDispatch] = useReducer(formReducer, formState);
  const customerInfo = useSelector((store) => store.userConfig.userProfileInfo);
  const currencyLookup = useSelector((store) => store.trasferReducer?.currencyLookup);
  const networkLookup = useSelector((store) => store.trasferReducer?.networkLookup);
  const merchantLookup = useSelector((store) => store.trasferReducer?.merchantLookup);
  const currency = useSelector((store) => store.trasferReducer?.currencyData);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const errorMessage = localState.errors || currencyLookup?.error || networkLookup?.error || merchantLookup?.error;
  const { switchNetwork } = useSwitchNetwork();
  const { address: connectedAddress } = useAccount();
  const breadCrumbList = [
    { id: '1', bname: 'Dashboard', url: '/dashboard' },
    { id: '2', bname: 'Transfer' }
  ];
  const chainId = arcanaAuth?.provider?.chainId;
  const allValues = form.getFieldsValue();
  useEffect(() => {
    if (allValues?.networkName) {
      const selectedNetworkId = networkLookup.data?.find(network => network.name == allValues?.networkName);
      setSelectedNetwork(selectedNetworkId);
    }
  }, [allValues?.networkName]);
  useEffect(() => {
    store.dispatch(fetchMerchantLookup(customerInfo?.id));
    store.dispatch(fetchCurrencyLookup(customerInfo?.id));
    return () => {
      store.dispatch(setMerchantData(
        { key: "merchantLookup", isLoading: false, data: null, error: null }
      ));
      store.dispatch(setCurrencyLookup(
        { key: "currencyLookup", isLoading: false, data: [], error: null }
      ));
      store.dispatch(setNetworksData(
        { key: "networkLookup", isLoading: false, data: [], error: null }
      ));
    };
  }, []);
  useEffect(()=>{
    let selectedMerchant = null;
    if (localState.values.merchantId) {
      const selectedMerchantName = merchantLookup?.data?.find(merchant => merchant.id === localState.values.merchantId);
      selectedMerchant = selectedMerchantName.name;
    }
    if(localState.values.coinName && localState.values.networkName && selectedMerchant){
      store.dispatch(fetchCurrency(localState.values.coinName,localState.values.networkName,selectedMerchant,customerInfo?.id));     
    }
    return () => {
      store.dispatch(setCurrencyData(
        { key: "currencyData", isLoading: false, data: null,error: null }
      ));
    };

  },[allValues?.networkName]);
  const handleCreate = async (val) => {
    const trimValues = (obj) => {
      let trimmedObj = {};
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim();
        } else {
          trimmedObj[key] = obj[key];
        }
      });
      return trimmedObj;
    };
    const values = trimValues(val);
    try {
      localDispatch({ type: 'setIsLoading', payload: true });
      localDispatch({ type: 'setErrors', payload: null });
      let saveObj = {
        "customerId": customerInfo?.id,
        "merchantId": values?.merchantId,
        "toAddress": values.ToAddress,
        "amount": values.amount,
        "coin": values.coinName,
        "network": values.networkName,
      }
      const coinType = saveObj.coin.toLowerCase();
      const networkType = networkToCoinMapping[saveObj.network] || coinType;
      let valideAddress;
      if (coinType === 'ybt') {
        valideAddress = WAValidator.validate(saveObj?.toAddress, 'eth', { chainType: 'ethereum' });
      } else {
        valideAddress = WAValidator.validate(saveObj?.toAddress, saveObj?.coin.toLowerCase(), { chainType: networkType });
      }

      if (!valideAddress) {
        localDispatch({ type: 'setErrors', payload: 'Invalid address' });
        localDispatch({ type: 'setIsLoading', payload: false });
        return;
      }
      if (Number(saveObj.amount) === 0) {
        localDispatch({ type: 'setErrors', payload: 'Amount must be greater than zero' });
        localDispatch({ type: 'setIsLoading', payload: false });
        return;
      }
      if (Number(saveObj.amount) > currency?.data) {
        localDispatch({ type: 'setErrors', payload: 'Insuficient funds' });
        localDispatch({ type: 'setIsLoading', payload: false });
        return;
      }
      if (WalletType === 'non_custodial') {
        try {
          if (saveObj?.toAddress === connectedAddress) {
            localDispatch({ type: 'setErrors', payload: "You cannot withdraw to your own address" });
            localDispatch({ type: 'setIsLoading', payload: false });
            return
          }
          let switchNetErr
          if (![selectedNetwork?.hexId, selectedNetwork?.chainId].includes(chainId?.toString())) {
            switchNetErr = await switchNetwork(selectedNetwork?.chainId);
          }
          if (switchNetErr) {
            localDispatch({ type: 'setErrors', payload: switchNetErr });
            localDispatch({ type: 'setIsLoading', payload: false });
            return;
          }
          const provider = arcanaAuth?.provider;
          const browserProvider = new BrowserProvider(provider);
          const signer = await browserProvider.getSigner();
          const senderAddress = await signer.getAddress()
          const feeData = await browserProvider.getFeeData();
          const gasPrice = feeData.gasPrice;
          const naviteBalance = await browserProvider.getBalance(senderAddress);
          const { coin: tokenName, toAddress: recevierAddress, amount } = saveObj || {}
          const { address: tokenAddress, decimals: tokenDecimals } = selectedNetwork || {}
          const Amount = parseUnits(amount, Number(tokenDecimals || 18));
          let transactionResponse;
          const handleTokenTransfer = async () => {
            const tokenContract = new Contract(tokenAddress, ERC20_ABI, signer);
            async function estimateGasForTransfer() {
              const tx = {
                from: senderAddress,
                value: '0x0',
                to: tokenAddress,
                data: tokenContract.interface.encodeFunctionData('transfer', [recevierAddress, Amount])
              };
              return browserProvider.estimateGas(tx);
            }
            const tokenBalance = await tokenContract.balanceOf(senderAddress);
            if (tokenBalance < Amount) {
              localDispatch({ type: 'setErrors', payload: `Insufficient ${tokenName} Balance: You do not have enough tokens.` });
              return;
            }
            const gasLimit = await estimateGasForTransfer();
            const gasCost = gasPrice * gasLimit;
            if (naviteBalance < gasCost) {
              localDispatch({ type: 'setIsLoading', payload: false });
              localDispatch({ type: 'setErrors', payload: `Insufficient Balance: You do not have enough native tokens to cover gas fees.` });
              return;
            }
            return tokenContract.transfer(recevierAddress, Amount);
          }
          const nativeTransfer = async () => {
            const transactionParameters = {
              to: recevierAddress,
              value: Amount,
            };
            const gasLimit = await browserProvider.estimateGas(transactionParameters);
            const totalCost = Amount + (gasPrice * gasLimit);
            if (naviteBalance < totalCost) {
              localDispatch({ type: 'setIsLoading', payload: false });
              localDispatch({ type: 'setErrors', payload:`Insufficient Balance: You do not have enough ${tokenName} to cover the transfer and gas fees.` });
              return;
            }
            return signer.sendTransaction({ ...transactionParameters, gasLimit, gasPrice });
          }
          if (!tokenAddress) {
            transactionResponse = await nativeTransfer()
          } else {
            transactionResponse = await handleTokenTransfer()
          }

          const receipt = await transactionResponse?.wait();
          if (receipt?.hash) {
            let response = await transferDetailes('Merchant/merchanttransfer', saveObj);
            if (response?.ok) {
              let _obj = {
                ...values,
                ToAddress: response?.ToAddress,
                amount: response?.amount,
                merchantName: response?.merchantName,
                id: response?.id,
                status: response?.status
              }
              reducerDispatch(setTrasferSaveData(_obj));
              message.success({
                content: "Transfered successfully!",
                className: 'custom-msg',
                duration: 1
              });
              localDispatch({ type: 'setIsLoading', payload: false });
              setTimeout(() => {
                history.push('/dashboard')
              }, 2000);
            } else {
              localDispatch({ type: 'setIsLoading', payload: false });
              localDispatch({ type: 'setErrors', payload: isErrorDispaly(response) });
              return;
            }
          }
        }catch (error) {
          localDispatch({ type: 'setIsLoading', payload: false });
          localDispatch({ type: 'setErrors', payload: isErrorDispaly(error) });
        }
      } else {
        try {
          let response = await transferDetailes('Merchant/merchanttransfer', saveObj);
          if (response?.ok) {
            let _obj = {
              ...values,
              ToAddress: response?.ToAddress,
              amount: response?.amount,
              merchantName: response?.merchantName,
              id: response?.id,
              status: response?.status
            }
            reducerDispatch(setTrasferSaveData(_obj));
            message.success({
              content: "Transfered successfully!",
              className: 'custom-msg',
              duration: 1
            });
            setTimeout(() => {
              history.push('/dashboard')
            }, 2000);
          } else {
            localDispatch({ type: 'setErrors', payload: isErrorDispaly(response) });
            localDispatch({ type: 'setIsLoading', payload: false });
            return;
          }
        } catch (error) {
          localDispatch({ type: 'setErrors', payload: isErrorDispaly(error.message) });
        }finally{
          localDispatch({ type: 'setIsLoading', payload: false });
        }
      }
    } catch (error) {
      localDispatch({ type: 'setErrors', payload: isErrorDispaly(error.message) });
    }finally{
      localDispatch({ type: 'setIsLoading', payload: false });
    }
  }
 
  const setField = (field, value) => {
    form.setFieldsValue({ [field]: value });
    let _obj = { ...localState.values };
    if(field === 'coinName'){
      form.resetFields(['networkName'])
      _obj['networkName'] = '';
      store.dispatch(fetchNetworks(value, customerInfo?.id));
    }
    if(field === 'merchantId'){
      form.resetFields(['networkName','coinName','ToAddress','amount']);
    }
    _obj[field] = value;
    localDispatch({ type: 'setValues', payload: _obj })
  };
  const clearError=(val)=>{
    if(currencyLookup.error){
      store.dispatch(setCurrencyLookup({ key: "currencyLookup", isLoading: false, data: [],error:val }));
    }else if(networkLookup?.error){
      store.dispatch(setNetworksData({ key: "networkLookup", isLoading: false, data: [],error:val }));
    }else if(merchantLookup?.error){
      store.dispatch(setMerchantData({ key: "merchantLookup", isLoading: false, data: [], error: val }));
    }else{
      localDispatch({ type: 'setIsLoading', payload: false });
      localDispatch({ type: 'setErrors', payload: val });
    }
  }    
  const handleRedirection =()=>{
    history.push('/dashboard')
  }
  return (
    <>
      <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
      {currencyLookup.isLoading && <Loader />}
      {!currencyLookup.isLoading &&
      <div className="layout-bg right-panel panel-bg tracnsaction-details">
      {errorMessage && (
            <div className="alert-flex" style={{ width: "100%" }}>
                <AppAlert
                    className="w-100 "
                    type="warning"
                    description={errorMessage}
                    showIcon
                />
                <span className="icon sm alert-close" onClick={() =>clearError(null) }></span>
            </div>
          )}
          <div className="form-title mb-24">
          <div className="d-flex align-items-center">
                  <span className="icon lg btn-arrow-back c-pointer" onClick={handleRedirection}></span>
                  <span className="card-title card-head">Transfer  </span>
                </div>
                </div>
          <div className="transfer-form">
            <Form
              form={form}
              className="payees-form custom-label mb-0 fw-400"
              onFinish={handleCreate}
              scrollToFirstError
            >
              <div className="mt-0">
                <Row gutter={[16, 16]} className="">
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    <div className={`text-left payee-field p-relative mb-24`}>
                      <div className="payee-token p-absolute">
                        <div className="payee-coinselect">
                          <div className="mbl-ellipse">
                            <span className="payee-label">
                              Merchant <span className="text-red">*</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="text-left">
                        <Form.Item
                          name="merchantId"
                          rules={[{ required: true, message: "Is required" }]}
                          className="mb-0"
                          colon={false}
                        >
                          <Select
                            onChange={(e) => setField("merchantId", e)}
                            placeholder="Select Merchant"
                            className="payee-input input-bordered"
                            maxLength={30}
                          >
                            {merchantLookup?.data?.map((item, index) => (
                              <Option key={index} value={item.id}>
                                {item?.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    <div className={`text-left payee-field p-relative mb-20`}>
                      <div className="payee-token p-absolute">
                        <div className="payee-coinselect">
                          <div className="mbl-ellipse">
                            <span className="payee-label">
                              Select Coin <span className="text-red">*</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="text-left">
                        <Form.Item
                          name="coinName"
                          rules={[{ required: true, message: "Is required" }]}
                          className="mb-0"
                          colon={false}
                        >
                          <Select
                            placeholder="Select Coin"
                            className="payee-input input-bordered"
                            onChange={(e) => setField('coinName', e)}
                          >
                            {currencyLookup?.data?.map((item) => (
                              <Option key={item?.id} value={item?.code}>
                                <span className={`active-coin crypto coin sm ${item.code.toLowerCase()} mr-6`}></span>
                                <span>{item?.code}</span>
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    <div className={`text-left payee-field p-relative mb-20`}>
                      <div className="payee-token p-absolute">
                        <div className="payee-coinselect">
                          <div className="mbl-ellipse">
                            <span className="payee-label">
                              Select Network <span className="text-red">*</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      {networkLookup?.isLoading && <div className="select-spinner-position"><SpinLoader /></div>}
                      <div className="text-left">
                        <Form.Item
                          className=""
                          name="networkName"
                          rules={[{ required: true, message: "Is required", whitespace: true }]}
                        >
                          <Select
                            className="payee-input input-bordered"
                            placeholder="Select Network"
                            type="input"
                            maxLength={100}
                            onChange={(e) => setField('networkName', e)}
                          >
                            {networkLookup?.data?.map((item) => (
                              <Option key={item.id} value={item.name}>
                                <span>{item?.name}</span>
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    <Form.Item
                      className="payees-input m-0 error-block mb-20 lineheight-normal"
                      name="ToAddress"
                      label="To Address"
                      colon={false}
                      rules={[
                        { required: true, message: "Is required", whitespace: true },
                        {
                          validator: validateContentRule,
                        },
                      ]}
                    >
                      <input
                        className="payees-input input-bordered text-left pl-18"
                        placeholder="Enter To Address"
                        type="input"
                        maxLength={100}
                      />
                    </Form.Item>

                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    <div>
                      <Form.Item
                        className="payees-input lineheight-normal"
                        name="amount"
                        label="Amount"
                        colon={false}
                        rules={[{ required: true, message: "Is required" }]}
                      >
                        <NumberFormat
                          className={'"payee-input input-bordered text-left pl-18'}
                          placeholder="0.00"
                          name={'amount'}
                          isAllowed={cryptoMaxAllowedDecimals}
                          thousandSeparator={true}
                          thousandsGroupStyle='lakh'
                          disabled={false}
                          allowNegative={false}
                          decimalScale={8}
                          onValueChange={(data) => {
                            setField('amount', data.floatValue);
                          }}
                        />
                      </Form.Item>
                    </div>
                   {allValues?.coinName && <p className="input-note text-right">
                      Available balance :{' '}
                      <span className="text-white">
                        <NumberFormat
                         value ={currency?.data ||'0.00000000'}
                          displayType={'text'}
                          thousandSeparator={true}
                          decimalScale={8}
                          fixedDecimalScale={true} // Ensure trailing zeros are kept
                        /> {allValues?.coinName ? allValues?.coinName : ''}
                      </span>
                    </p>}
                  </Col>
                </Row>

                <Form.Item className="mt-30  mb-0">
                  <Button block className="btn-style mt-30" htmlType="submit" style={{ marginLeft: '0px',width:"100%" }}
                    loading={ localState.isLoading } disabled={ localState.isLoading}>
                    { localState.isLoading ? 'Confirming...' : 'Send'}<span className="icon lg right-arrow c-pointer" />
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </div>}
    </>
  );
};

export default TransferComponent;
